import { useState, useRef } from "react";
import { Modal, IconButton, Box } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import userProfile from "assets/images/user-profile.png";
import EditIcon from "@mui/icons-material/Edit";
import { addModerator } from "services/moderatorService";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  py: 5,
  px: 8,
};

function ModeratorModal({ open, handleClose, onUpdate }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    avatar: userProfile,
  });

  const [avatarPreview, setAvatarPreview] = useState(userProfile);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef();

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleChange(name, value);
  };

  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setAvatarPreview(ev.target.result);
        handleChange("avatar", ev.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please fill all the fields");
      return;
    }

    const payload = new FormData();
    payload.append("name", form.name);
    payload.append("email", form.email);

    // If a file is selected, append it
    const file = fileInputRef.current?.files[0];
    if (file) {
      payload.append("avatar", file);
    }
    try {
      setLoading(true);
      await addModerator(payload);
      toast.success("Moderator added successfully");
      handleClose();
      onUpdate();
      setLoading(false);
    } catch (err) {
      toast.error(err.response.data.message);
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <form onSubmit={handleSubmit}>
          <ArgonBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            mb={3}
          >
            <ArgonTypography variant="h4" fontWeight="medium" mb={2}>
              Add Moderator
            </ArgonTypography>
            <Box position="relative" mb={2}>
              <img
                src={avatarPreview}
                alt="avatar"
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
              <IconButton
                onClick={handleAvatarClick}
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  bgcolor: "#2d3f50",
                  borderRadius: "12px",
                }}
                size="small"
              >
                <EditIcon fontSize="small" color="white" />
              </IconButton>
              <input
                type="file"
                accept="image/jpeg, image/png, image/jpg"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleAvatarChange}
              />
            </Box>
          </ArgonBox>
          <ArgonBox mb={2}>
            <ArgonTypography variant="h6" fontWeight="bold" mb={1}>
              Name
            </ArgonTypography>
            <ArgonInput
              name="name"
              value={form.name}
              onChange={handleInputChange}
              fullWidth
            />
          </ArgonBox>
          <ArgonBox mb={3}>
            <ArgonTypography variant="h6" fontWeight="bold" mb={1}>
              Email
            </ArgonTypography>
            <ArgonInput
              name="email"
              type="email"
              value={form.email}
              onChange={handleInputChange}
              fullWidth
            />
          </ArgonBox>
          <ArgonBox display="flex" justifyContent="center" gap={2}>
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              type="button"
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add"}
            </ArgonButton>
          </ArgonBox>
        </form>
      </Box>
    </Modal>
  );
}

export default ModeratorModal;
